import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
import profile from "assets/images/och/userr.jpeg";
import dummyuser from "assets/images/och/dummyuser.png";
import overMan from "assets/images/och/game-over-man.png";
const OCHOver = ({  players,PlayersRankInfo}) => {

  const testArray = [];
  for (let item of players) {
    if (item?.total_score === undefined) {
      testArray.push({...item, total_score: 0});
    } else {
      testArray.push({...item});
    }
  }

  const sortPlayersHands = testArray?.sort(
    (a, b) => parseInt(b.total_score, 10) - parseInt(a.total_score, 10),
  );
  const winnerID = sortPlayersHands[0]?.player_id;


const winnerInfo=PlayersRankInfo?.find(
    (user) => user?.player_id === winnerID
  );
  const loosePlayer=PlayersRankInfo?.filter(
    (user) => user?.player_id != winnerID
  );
  return (
    <motion.div  variants={divVariants}
    initial="hidden"
    animate="visible"
    exit="exit" className="game-over">
      <motion.h2 variants={fadeVariants}  className="title">Game Over!</motion.h2>
      <motion.div variants={staticBounceVariants}   className="game-img">
        <img src={overMan} className="img-fluid profile" alt="" />
      </motion.div>
      <motion.div variants={staticBounceVariants}   className="winner-data">
        <div className="winner-img">
          <img
            src={winnerInfo?.profile_image}
            className="img-fluid profile"
            alt=""
          />
        </div>
        <div className="winner-name">
          <p className="txt1">Winner</p>
          <p className="txt2">{winnerInfo?.display_name}</p>
        </div>
      </motion.div>
      <div className="top-players">
        {loosePlayer?.map((item) => (
          <motion.div variants={staticBounceVariants}  className="player-box">
            <div className="position-box">
              <p className="name">{item?.rank_tag}</p>
            </div>
            {item?.profile_image ==="profileImage"?<img
                    src={dummyuser}
                    className="img-fluid profile"
                    alt=""
                  /> : <img
                    src={item?.profile_image}
                    className="img-fluid profile"
                    alt=""
                  />}
            <div className="name-box">
              <p className="name">{item?.display_name}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default OCHOver;
